import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexColumn, FlexRow } from "./common.styles";
export const ReasonsBody = styled(FlexColumn) `
    gap: 16px;
    width: 100%;
`;
export const ReasonsDescription = styled.p `
    margin: 0;
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_light};
    line-height: 24px;
    letter-spacing: -0.31px;
`;
export const ReasonsCheckboxList = styled(FlexColumn) `
    gap: 0;
    padding: 16px 8px 0;
    width: 100%;
`;
const CHECKBOX_INSET = "42px";
export const ReasonsCheckboxRow = styled(FlexRow) `
    position: relative;
    align-items: center;
    padding: 4px 0;

    &::after {
        content: "";
        position: absolute;
        left: ${CHECKBOX_INSET};
        right: 0;
        bottom: 0;
        border-bottom: 0.37px solid ${colors.separator_main};
    }

    &:last-child::after {
        display: none;
    }
`;
export const ReasonsButtonRow = styled(FlexRow) `
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
    padding-top: 16px;
`;
